import { ICarePlanMedicationsStore } from './types';

const initStore: ICarePlanMedicationsStore = {
  items: [],
};

export default initStore;
